import { Field, useFormikContext } from "formik";
import React, { FC, useRef } from "react";
import Label from "../../../components/label/label";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { validateEmail, validateItemName } from "../../../utilities/Validation";
import Togglebox from "../../../components/togglebox/togglebox";

const EmailAccountCard: FC = () => {
    const { translate } = useLocale();
    const inputRef = useRef<HTMLInputElement>(null);
    const { errors } = useFormikContext<any>();

    return (
        <div className="w-full p-2 inline-flex justify-start items-center bg-white flex-col">
            <div className="flex w-full space-x-20 py-4 px-8">
                <div className="mb-2">
                    <div
                        className="flex flex-row justify-between"
                        id="emailAccountDiv"
                    >
                        <Label
                            htmlFor="name"
                            className="text-xs text-gray-600 mt-1"
                            required
                        >
                            {translate.byKey(TranslationKeys.emailAccount)}:
                        </Label>
                            {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                    </div>
                    <div className="flex flex-row justify-between">
                        <Field
                            type="text"
                            innerRef={inputRef}
                            name="name"
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                            validate={(value) => validateItemName(value, translate)}
                            id="emailAccountInputId"
                            style={{ width: "230px" }}
                        />
                    </div>
                </div>
                
                <div className="mb-2">
                    <div
                        className="flex flex-row justify-between mb-1"
                        id="enabled"
                    >
                        <Label
                            htmlFor="enabled"
                            className="text-xs text-gray-600 mt-1"
                        >
                            {translate.byKey(TranslationKeys.enabled)}:
                        </Label>
                    </div>
                    <div className="flex flex-row justify-between" id="enabledTogglebox">
                        <Togglebox name="enabled" label={""} />
                    </div>
                </div>
            </div>

            <div className="flex w-full space-x-20 px-8">
                <div className="mb-2">
                    <div
                        className="flex flex-row justify-between"
                        id="addressDiv"
                    >
                        <Label
                            htmlFor="address"
                            className="text-xs text-gray-600 mt-1"
                            required
                        >
                            {translate.byKey(TranslationKeys.address)}:
                        </Label>
                            {errors.address ? <span className='text-red-600 text-xs'>{errors.address['label']}</span> : null}
                    </div>
                    <div className="flex flex-row justify-between">
                        <Field
                            type="text"
                            innerRef={inputRef}
                            name="address.label"
                            className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                            validate={(value) => validateEmail(value, translate, true)}
                            id="emailAddressId"
                            style={{ width: "230px" }}
                        />
                    </div>
                </div>

                <div className="mb-2">
                    <div
                        className="flex flex-row justify-between mb-1"
                        id="DefaultAccount"
                    >
                        <Label
                            htmlFor="DefaultAccount"
                            className="text-xs text-gray-600 mt-1"
                        >
                            {translate.byKey(TranslationKeys.defaultAccount)}:
                        </Label>
                    </div>
                    <div className="flex flex-row justify-between" id="defaultAccountTogglebox">
                        <Togglebox name="defaultAccount" label={""} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EmailAccountCard;
